import React from "react";
import { Box, useTheme, Typography, Card, CardContent, Divider } from "@mui/material";
import { useLocation } from "react-router-dom";
import { Header } from "components";

const CustomerSubscriptionDetails = () => {
  const theme = useTheme();
  const state = useLocation();
  const { name, email, username, planDetails } = state.state || {};

  return (
    <Box m="1.5rem 2.5rem">
      {/* Header */}
      <Header
        title="Customer Subscription Details"
        subtitle={`Name: ${name} | Email: ${email} | Username: ${username}`}
      />

      {/* Plan Details Section */}
      <Card
        sx={{
          mt: 4,
          borderRadius: "12px",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
          backgroundColor: theme.palette.background.alt,
        }}
      >
        <CardContent>
          {planDetails ? (
            <>
              <Typography
                variant="h5"
                gutterBottom
                sx={{ fontWeight: "bold", color: theme.palette.secondary[300] }}
              >
                Plan Details
              </Typography>
              <Divider sx={{ mb: 3, bgcolor: theme.palette.secondary[200] }} />

              <Box display="flex" flexDirection="column" gap={2}>
                <Typography variant="h6">
                  <strong>Name:</strong> {planDetails.name}
                </Typography>
                <Typography variant="h6">
                  <strong>Status:</strong>{" "}
                  <span
                    style={{
                      color: planDetails.active ? "#38A3A5" : "#ff5252",
                      fontWeight: "bold",
                    }}
                  >
                    {planDetails.active ? "Active" : "Inactive"}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <strong>Start:</strong>{" "}
                  {new Date(planDetails.startPeriod).toLocaleString()}
                </Typography>
                <Typography variant="h6">
                  <strong>End:</strong>{" "}
                  {new Date(planDetails.endPeriod).toLocaleString()}
                </Typography>
              </Box>
            </>
          ) : (
            <Typography color="error" variant="h6">
              No plan details found.
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default CustomerSubscriptionDetails;
